import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import { services } from "@/data/siteData";

export default function ServicesSection({ onQuote }) {
  return (
    <section className="services-section" id="services" data-testid="services-catalog-section">
      <div className="section-shell">
        <Reveal className="services-intro" delay={70}>
          <div><div className="eyebrow"><span className="eyebrow__dot" /> 02 / Our professional services</div><h2>Every environment.<br /><em>Considered.</em></h2></div>
          <p>From a private villa before guests arrive to a working facility that never stops, our teams bring the same quiet rigor to every assignment.</p>
        </Reveal>
        <div className="service-grid">
          {services.map((service, index) => {
            const Icon = service.icon;
            return <Reveal as="article" className={`service-card ${index % 3 === 0 ? "service-card--wide" : ""}`} delay={80 + (index % 4) * 70} key={service.id} data-testid={`service-card-item-${service.id}`}>
              <div className="service-card__topline"><span className="service-card__number">{service.number}</span><span className="service-card__category"><Icon size={15} /> Premier service</span></div>
              <figure className="service-card__photo"><img src={service.image} alt={service.alt} loading="lazy" /><figcaption>Signature care / {service.number}</figcaption></figure>
              <div className="service-card__body">
                <h3 className="service-card__title">{service.title}</h3>
                <p className="service-card__short">{service.short}</p>
                <p className="service-card__description">{service.description}</p>
                <div className="transformation-slot" data-testid={`transformation-slot-${service.id}`}>
                  <div className="transformation-pane transformation-pane--before" style={{ backgroundImage: `url(${service.image})` }}><span>Before / detail pending</span></div>
                  <div className="transformation-pane transformation-pane--after"><img src={service.image} alt={`${service.title} finished result`} loading="lazy" /><span>After / premier finish</span></div>
                </div>
                <div className="service-card__details"><span>Included in the brief</span><ul>{service.deliverables.map((deliverable) => <li key={deliverable}>{deliverable}</li>)}</ul></div>
                <div className="service-card__footer"><span className="service-card__ideal">Ideal for<br /><strong>{service.idealFor}</strong></span><button className="button button--dark button--small" type="button" onClick={() => onQuote(service.title)} data-testid={`service-quote-trigger-${service.id}`}>Request this service <ArrowUpRight size={15} /></button></div>
              </div>
            </Reveal>;
          })}
        </div>
      </div>
    </section>
  );
}
